import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { taka } from "@/lib/api";
import { Modal, Field, inputCls, Th, Td, Empty, fmtDate } from "@/pages/admin/AdminUI";

const CATS = ["বিদ্যুৎ", "গ্যাস/ডিজেল", "শ্রমিক", "পরিবহন", "মেশিন রক্ষণাবেক্ষণ", "প্যাকেজিং", "গুদাম", "ভাড়া", "বেতন", "অন্যান্য"];

export default function AdminExpenses() {
  const [expenses, setExpenses] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ category: "বিদ্যুৎ", amount: 0, note: "" });

  const load = () => api.get("/admin/expenses").then((r) => setExpenses(r.data));
  useEffect(() => { load(); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.amount) return toast.error("পরিমাণ দিন");
    await api.post("/admin/expenses", { ...form, amount: Number(form.amount) }); toast.success("খরচ যোগ হয়েছে"); setOpen(false); setForm({ category: "বিদ্যুৎ", amount: 0, note: "" }); load();
  };
  const del = async (id) => { if (!window.confirm("মুছবেন?")) return; await api.delete(`/admin/expenses/${id}`); load(); };

  const total = expenses.reduce((s, e) => s + e.amount, 0);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-2xl font-bold text-[#1E3A2B]">খরচ ব্যবস্থাপনা</h1>
        <button onClick={() => setOpen(true)} className="bg-[#1E3A2B] text-white h-11 px-4 rounded-xl flex items-center gap-2 font-medium" data-testid="add-expense-btn"><Plus size={18} /> খরচ যোগ</button>
      </div>
      <div className="bg-white rounded-2xl border border-stone-200 p-4 inline-block"><div className="text-sm text-stone-500">মোট খরচ</div><div className="text-2xl font-bold text-red-600">{taka(total)}</div></div>
      <div className="bg-white rounded-2xl border border-stone-200 overflow-x-auto">
        <table className="w-full min-w-[560px]">
          <thead className="bg-stone-50 border-b border-stone-200"><tr><Th>তারিখ</Th><Th>ক্যাটাগরি</Th><Th>নোট</Th><Th>পরিমাণ</Th><Th></Th></tr></thead>
          <tbody className="divide-y divide-stone-100">
            {expenses.map((e) => (
              <tr key={e.id} data-testid={`expense-row-${e.id}`}>
                <Td>{fmtDate(e.date)}</Td><Td className="font-medium">{e.category}</Td><Td>{e.note}</Td>
                <Td className="font-semibold text-red-600">{taka(e.amount)}</Td>
                <Td><button onClick={() => del(e.id)} className="p-2 text-red-500" data-testid={`delete-expense-${e.id}`}><Trash2 size={16} /></button></Td>
              </tr>
            ))}
          </tbody>
        </table>
        {expenses.length === 0 && <Empty />}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title="খরচ যোগ করুন">
        <div className="space-y-3">
          <Field label="ক্যাটাগরি"><select className={inputCls} value={form.category} onChange={(e) => set("category", e.target.value)} data-testid="exp-category">{CATS.map((c) => <option key={c}>{c}</option>)}</select></Field>
          <Field label="পরিমাণ (৳)"><input type="number" className={inputCls} value={form.amount} onChange={(e) => set("amount", e.target.value)} data-testid="exp-amount" /></Field>
          <Field label="নোট"><input className={inputCls} value={form.note} onChange={(e) => set("note", e.target.value)} /></Field>
          <button onClick={save} className="w-full bg-[#1E3A2B] text-white h-11 rounded-xl font-medium" data-testid="save-expense-btn">সংরক্ষণ</button>
        </div>
      </Modal>
    </div>
  );
}
